import { FormsContext } from '@ngt/forms';
import { JsonServiceClient } from '@servicestack/client';
import { useCallback, useContext, useMemo } from 'react';
import useSWR, { mutate, SWRConfiguration } from 'swr';
import { LookupTypeGetCollectionBySearch, LookupTypeSearchResponse } from '../apis/dtos';
import { BoundMutator } from '../utilities/BoundMutator';


// @ts-ignore: declared but not used 'url'
const fetcher = async (
    url: string,
    client: JsonServiceClient,
    name?: string,
    page?: number,
    rows?: number,
) =>
{
    return await client?.get(new LookupTypeGetCollectionBySearch({
        name,
        page,
        pageSize: rows
    }));
}

const urlKey = '/api/lookup-types';

const useLookupTypes = (
    name?: string,
    page?: number,
    rows?: number,
    configuration?: SWRConfiguration<LookupTypeSearchResponse, LookupTypeSearchResponse>
) =>
{
    const { serviceStackClient: client } = useContext(FormsContext);

    const cacheKey = useMemo(() =>
    {
        return [urlKey, client, name, page, rows]
    }, [client, name, page, rows])

    const { data, error } = useSWR<LookupTypeSearchResponse, LookupTypeSearchResponse>(cacheKey, fetcher, configuration);

    const boundMutate: BoundMutator<LookupTypeSearchResponse> = useCallback((data, shouldRevalidate) =>
    {
        return mutate(cacheKey, data, shouldRevalidate);
    }, [cacheKey]);

    return {
        data: data?.data,
        total: data?.count,
        error: error?.responseStatus,
        loading: data === undefined && error === undefined,
        mutate: boundMutate
    };
}

export default useLookupTypes;